import React from "react";
import { SettingsIcon, MailIcon } from "lucide-react";
export function Support() {
  return <footer className="px-4 py-8" data-id="element-185" data-mp="1crwqfydwkq4u">
      <div className="flex flex-col items-center gap-3 rounded-2xl border border-white/10 bg-[#0f2c4a]/85 p-6 text-center backdrop-blur-sm" data-id="element-186" data-mp="1cqv4uzz9gl8v">
        <SettingsIcon className="h-9 w-9 text-[#8bc34a]" data-id="element-187" data-mp="12t76m02g4vly" />
        <p className="text-sm font-semibold text-slate-100" data-id="element-188" data-mp="12rmd8drvbipo">
          Soporte y ayuda
        </p>
        <a href="mailto:EbookDreamShop@gmail.com" className="inline-flex items-center gap-2 text-sm font-bold text-[#8bc34a] underline underline-offset-2" data-id="element-189" data-mp="p07w6chitrl9">
          <MailIcon className="h-4 w-4" data-id="element-190" data-mp="f4xphbg6gw15" />
          EbookDreamShop@gmail.com
        </a>
        <p className="text-[11px] text-slate-400" data-id="element-191" data-mp="k3r6hduob562">
          © {new Date().getFullYear()} Profe Fútbol Resuelto — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}